@if (selectedAlarm()) {
  <div class="alarm-details-content">
    <div class="details-card">
      <div class="card-header">
        <div class="header-content">
          <h2>Detalles de Alarma</h2>
          <p>Información completa del evento</p>
        </div>
        @if (!isClassificationEnabled()) {
          <button
            mat-icon-button
            (click)="showHelp()"
            matTooltip="Ver ayuda"
            class="help-btn"
            style="color: #1976d2"
            >
            <mat-icon>help_outline</mat-icon>
          </button>
        }
        @if (isClassificationEnabled()) {
          <button
            mat-icon-button
            (click)="showHelpLotes()"
            matTooltip="Ver ayuda"
            class="help-btn"
            style="color: #1976d2"
            >
            <mat-icon>help_outline</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          (click)="closeDetails()"
          matTooltip="Cerrar detalle"
          class="close-button"
          >
          <mat-icon class="close-icon">close</mat-icon>
        </button>
      </div>
      <div class="divider"></div>
      <div class="card-content">
        <div class="alarm-info-grid">
          @if (!isClassificationEnabled()) {
            <div class="location-info-card">
              <div class="location-info-header">
                <div class="section-title">
                  <span class="section-icon">📍</span>
                  Ubicación
                </div>
              </div>
              <div class="location-info-content">
                <app-map
              [center]="[
                selectedAlarm().gpsReport.latitude,
                selectedAlarm().gpsReport.longitude
              ]"
              [singlePosition]="{
                latitude: selectedAlarm().gpsReport.latitude,
                longitude: selectedAlarm().gpsReport.longitude,
                name: selectedAlarm().gpsReport.assetName || 'Activo',
                device: selectedAlarm().gpsReport.deviceId,
                description: selectedAlarm().eventName,
                risklevel: 'medium',
                points: 100
              }"
                  [zoom]="15"
                  height="260px"
                  >
                </app-map>
              </div>
            </div>
          }
          @if (!isClassificationEnabled()) {
            <div class="basic-info-card">
              <div class="basic-info-header">
                <div class="section-title">
                  <span class="section-icon">📋</span>
                  Información Básica
                </div>
              </div>
              <div class="basic-info-content">
                <div class="info-grid">
                  <div class="info-item">
                    <div class="info-icon">🚗</div>
                    <div class="info-text">
                      <div class="info-value">
                        {{ selectedAlarm().gpsReport.assetName || "No disponible" }}
                      </div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-icon">📅</div>
                    <div class="info-text">
                      <div class="info-value">
                        {{ selectedAlarm().gpsReport.reportDate | date : "medium" }}
                      </div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-icon">🔔</div>
                    <div class="info-text">
                      <div class="info-value">
                        {{ selectedAlarm().gpsReport.eventName || "No disponible" }}
                      </div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-icon">📍</div>
                    <div class="info-text">
                      <div class="info-value">
                        {{ selectedAlarm().gpsReport.location || "No disponible" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="classification-info-card">
            <div class="classification-info-header">
              <div class="section-title-container">
                <div class="section-title">
                  <span class="section-icon">📝</span>
                  Clasificación
                </div>
                <div class="classification-checkbox">
                  <mat-checkbox
                    [checked]="isClassificationEnabled()"
                    (change)="toggleClassification($event.checked)"
                    >
                    <span class="por-lote-label">Por Lote</span>
                  </mat-checkbox>
                </div>
              </div>
            </div>
            @if (!isClassificationEnabled()) {
              <div
                class="classification-info-content"
                >
                <app-alarms-classification-form
                  [alarmData]="selectedAlarm()"
                  (classificationComplete)="handleClassificationComplete($event)"
                  >
                </app-alarms-classification-form>
              </div>
            }
            @if (isClassificationEnabled()) {
              <div
                class="batch-classification-content"
                >
                <h3>Alarmas del mismo activo</h3>
                <div class="selection-header">
                  <mat-checkbox
                    [checked]="isAllSelected()"
                    [indeterminate]="isSomeSelected()"
                    (change)="toggleAllAlarms($event.checked)"
                    class="select-all-checkbox all-holders-check white-checkbox-label"
                    >
                    Seleccionar todos
                  </mat-checkbox>
                  <span class="selected-count">
                    {{ getSelectedCount() }} seleccionados
                  </span>
                </div>
                @if (filteredAlarms().length) {
                  <div class="alarm-checkbox-list" (scroll)="onScrollAlarms($event)">
                    <mat-list class="mat-elevation-z8">
                      @for (alarm of filteredAlarms(); track alarm) {
                        <mat-list-item
                          class="alarm-checkbox-item"
                          >
                          <div class="alarm-checkbox-content">
                            <mat-checkbox
                      [checked]="
                        alarm.id && selectedAlarms.has(alarm.id.toString())
                      "
                      (change)="
                        toggleAlarmSelection(
                          alarm.id.toString(),
                          $event.checked
                        )
                      "
                              class="alarm-checkbox"
                              >
                            </mat-checkbox>
                            <div class="alarm-info-details">
                              <div class="alarm-holder">
                                <strong>Holder:</strong>
                                {{ alarm.gpsReport.assetId || "-" }}
                              </div>
                              <div class="alarm-event">
                                <strong>Evento:</strong>
                                {{ alarm.gpsReport.eventName || "-" }}
                              </div>
                              <div class="alarm-date">
                                <strong>Fecha:</strong>
                                {{ alarm.gpsReport.reportDate | date : "short" }}
                              </div>
                              <div class="alarm-location">
                                <strong>Ubicación:</strong>
                                {{ alarm.gpsReport.location || "-" }}
                              </div>
                            </div>
                          </div>
                          <mat-divider></mat-divider>
                        </mat-list-item>
                      }
                    </mat-list>
                    @if (isLoadingMore()) {
                      <div class="loading-more" style="text-align: center; padding: 8px;">
                        <span>Cargando más alarmas...</span>
                      </div>
                    }
                  </div>
                }
                @if (!filteredAlarms().length) {
                  <p class="no-alarms-message">
                    No hay alarmas que coincidan con los filtros.
                  </p>
                }
                <div class="classification-form-container">
                  <form
                    [formGroup]="classificationForm"
                    (ngSubmit)="onSubmit()"
                    class="classification-form"
                    >
                    <div class="form-group">
                      <label for="status">Estado:</label>
                      <select
                        id="status"
                        formControlName="status"
                        class="form-control"
                        >
                        <option value="" selected>Seleccione un estado</option>
                        @for (option of statusOptions; track option) {
                          <option [value]="option.value">
                            {{ option.label }}
                          </option>
                        }
                      </select>
                      @if (classificationForm.get('status')?.invalid && classificationForm.get('status')?.touched) {
                        <div
                          class="error-message"
                          >
                          Estado es requerido
                        </div>
                      }
                    </div>
                    <div class="form-group">
                      <label for="observations">Observaciones:</label>
                      <textarea
                        id="observations"
                        formControlName="observations"
                        class="form-control"
                        rows="3"
                        placeholder="Ingrese observaciones sobre la alarma"
                        >
                      </textarea>
                    </div>
                    <div class="form-actions">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="onCancel()"
                        >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="classificationForm.invalid"
                        >
                        Enviar Clasificación
                      </button>
                    </div>
                    <!-- <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div> -->
                    @if (errorMessage()) {
                      <div class="alert alert-danger">
                        {{ errorMessage() }}
                      </div>
                    }
                  </form>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
